import { UtilityText } from '@policygenius/mortar';
import React from 'react';

import { legalSectionLinks } from '../../data/footer';
import styles from './index.module.scss';

const LegalSection = () => (
  <div>
    <a href="/about/security/" className={`${styles.securityLink} ${styles.text}`}>
      <UtilityText size="small">Security you can trust</UtilityText>
    </a>

    <div className={styles.linkGroup}>
      {legalSectionLinks.map((link) => {
        const { href, text } = link;

        return (
          <a className={styles.link} href={href} key={`footer-legal-link-${text}`}>
            <UtilityText size="small">{text}</UtilityText>
          </a>
        );
      })}
    </div>
    <UtilityText as="p" size="small">
      Yes, we have to include some legalese down here. Policygenius LLC (DBA Policygenius Services
      LLC in NY; DBA Policygenius Insurance Services in California) (“Policygenius”), a Delaware
      corporation with its principal place of business in New York, New York, is a licensed
      independent insurance broker. The information provided on this site has been developed by
      Policygenius for general informational and educational purposes. We do our best to ensure that
      this information is up-to-date and accurate. Any insurance policy premium quotes or ranges
      displayed are non-binding. The final insurance policy premium for any policy is determined by
      the underwriting insurance company following application.
    </UtilityText>
    <p className={styles.text} />

    <UtilityText as="p" size="small">
      If you are using a screen reader and are having problems using this website, please call{' '}
      <a href="tel:1-855-695-2255" className={styles.phoneNumber}>
        1-855-695-2255
      </a>{' '}
      for assistance.
    </UtilityText>

    <UtilityText as="p" size="small" className={styles.copyright}>
      Copyright Policygenius © 2014-{new Date().getFullYear()} | NerdWallet Logo ©2014-2025 and TM,
      NerdWallet, Inc. All Rights Reserved.
    </UtilityText>
  </div>
);

export default LegalSection;
